import React from 'react';

const AboutPage = () => {
  return (
    <div style={{ minHeight: '60vh', padding: '80px 0' }} className="container">
      <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto', backgroundColor: 'white', padding: '60px', borderRadius: '16px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '20px' }}>About <span style={{ color: 'var(--primary-orange)' }}>ChaiY</span></h1>
        <h3 style={{ color: 'var(--primary-orange)', marginBottom: '30px' }}>Innovating the food industry with authentic flavors since 2022</h3>
        <p style={{ fontSize: '1.1rem', color: 'var(--text-gray)', lineHeight: '1.8', marginBottom: '20px', textAlign: 'left' }}>
          ChaiY was born out of a simple passion: to bring the true, unadulterated taste of authentic Indian street chai into the modern home. Starting our journey in 2022 in Dahanukar Colony, Pune, we realized that while the world was moving fast, the soul-comforting pause of a perfect cup of chai was being lost to artificial flavors.
        </p>
        <p style={{ fontSize: '1.1rem', color: 'var(--text-gray)', lineHeight: '1.8', textAlign: 'left' }}>
          We source the finest tea leaves and blend them with high-quality, natural spices to create our signature premixes. Whether you crave the fiery kick of ginger, the royal aroma of cardamom, or the nostalgic warmth of classic masala, ChaiY ensures that a perfect, cafe-quality cup is just hot water away.
        </p>
      </div>
    </div>
  );
};

export default AboutPage;